import React from 'react';
import { Users, MapPin, Briefcase, Monitor } from 'lucide-react';
import { Button } from './ui/button';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

export const Features = ({ onEnrollClick }) => {
  const [ref, isVisible] = useScrollAnimation(0.1);
  
  const features = [
    {
      icon: Users,
      title: '1:1 Personalized Training',
      description: 'Get individual attention with customized learning paths tailored to your skill level and career goals.',
      color: 'from-purple-500 to-pink-500'
    },
    {
      icon: MapPin,
      title: 'Offline Classes',
      description: 'Learn in a professional environment with hands-on experience and direct interaction with expert instructors.',
      color: 'from-pink-500 to-orange-500'
    },
    {
      icon: Briefcase,
      title: '100% Placement Support',
      description: '400+ students placed in 100+ companies. We prepare you for interviews and connect you with industry opportunities.',
      color: 'from-orange-500 to-amber-500'
    },
    {
      icon: Monitor,
      title: 'State-of-the-Art Facilities',
      description: 'Edit on industry-standard Apple workstations in our cool, modern office with professional ambience and working facilities that inspire creativity.',
      color: 'from-amber-500 to-purple-500'
    }
  ];

  return (
    <section className="py-16 md:py-20 bg-gradient-to-br from-slate-50 to-purple-50">
      <div className="container mx-auto px-6 lg:px-12">
        <div ref={ref} className={`text-center mb-12 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Why Choose <span className="bg-gradient-to-r from-purple-600 to-orange-600 bg-clip-text text-transparent">MatchFrame Editing School</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, idx) => {
            const Icon = feature.icon;
            return (
              <div 
                key={idx}
                className={`group bg-white rounded-3xl p-6 shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-500 border border-slate-100 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${idx * 150}ms` }}
              >
                <div className={`inline-flex p-3 rounded-2xl bg-gradient-to-br ${feature.color} mb-4 transform group-hover:rotate-6 group-hover:scale-110 transition-all duration-500`}>
                  <Icon className="h-7 w-7 text-white" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">{feature.title}</h3>
                <p className="text-slate-600 leading-relaxed">{feature.description}</p>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <Button
            onClick={onEnrollClick}
            className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white px-12 py-6 rounded-full text-lg font-semibold transform hover:scale-105 transition-all duration-300 border-0"
          >
            Enquire Now
          </Button>
        </div>
      </div>
    </section>
  );
};
